import { getCookieAmend } from './apiUtils';
import { localStorageKey, cookieStorageKey } from '@/utils/constants';
import { md5 } from 'js-md5';

const { paySessionIdKey } = localStorageKey;
const { QIMEI, GUID, H38 } = cookieStorageKey;

export const getPaySessionId = () => localStorage.getItem(paySessionIdKey) || '';
// 生成支付会话ID: 时间戳+设备ID的MD5值
export function generatePaySessionId() {
  try {
    // 获取毫秒级时间戳
    const timestamp = Date.now();
    // 获取设备ID (qimei或h38或guid)
    // const deviceId = getCookieAmend(QIMEI) || getCookieAmend(H38) || getCookieAmend(GUID) || '';
    const keys = [QIMEI, H38, GUID];
    let deviceId = '';
    for (const key of keys) {
      const value = getCookieAmend(key);
      if (value) {
        deviceId = value;
        break;
      }
    }
    // 拼接时间戳和设备ID
    const combinedString = `${timestamp}${deviceId}`;
    // 计算MD5
    const md5Hash = md5(combinedString);
    localStorage.setItem(paySessionIdKey, md5Hash);
    return md5Hash;
  } catch (error) {
    console.error('Failed to generate pay session id:', error);
    return '';
  }
}
